module.exports = __webpack_public_path__ + "media/media/product-card/accessory-2-bf3f59884d7092a6ecfdaecd2626b6c9.png";